import { forwardRef } from "react";
import { IconButton } from "@radix-ui/themes";
import { ArrowUpIcon } from "@radix-ui/react-icons";
import { IoSparkles } from "react-icons/io5";
import { SimulatorChannel } from "@/api/simulator/simulator.model";
import { InputType, SimulatorInput } from "../input";
import { ChatInputWrapper } from "./ChatInputWrapper";
import styles from "./ChatInput.module.scss";

interface ChatInputProps {
  channel?: SimulatorChannel;
  type: InputType;
  value: string;
  loading: boolean;
  disableInstructions: boolean;
  messagesLength: number;
  setType: (type: InputType) => void;
  handleInputChange: (e: any) => void;
  handleSubmit: () => void;
  handleResetConversation: (
    feedback?: "NEGATIVE" | "POSITIVE",
    feedbackComment?: string
  ) => Promise<void>;
}

export const ChatInput = forwardRef<HTMLTextAreaElement, ChatInputProps>(
  (
    {
      channel,
      type,
      value,
      loading,
      disableInstructions,
      messagesLength,
      setType,
      handleInputChange,
      handleSubmit,
      handleResetConversation,
    },
    ref
  ) => {
    return (
      <ChatInputWrapper channel={channel} messagesLength={messagesLength}>
        <div className={styles.inputFieldContainer}>
          <div className={styles.input}>
            <div className={styles.iconContainer}>
              <IoSparkles />
            </div>

            <SimulatorInput
              ref={ref}
              type={type}
              setType={setType}
              value={value}
              handleInputChange={handleInputChange}
              handleSubmit={handleSubmit}
              messagesLength={messagesLength}
              handleResetConversation={handleResetConversation}
              disableInstructions={disableInstructions}
            />
          </div>

          <IconButton
            size="1"
            type="submit"
            variant="soft"
            radius="full"
            color="gray"
            highContrast
            loading={loading}
          >
            <ArrowUpIcon />
          </IconButton>
        </div>
      </ChatInputWrapper>
    );
  }
);
